var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Vocabulary derivation rule detail / edit / create pane (CZNA-365).
 *
 * Drives both flows off one component:
 *  - edit: loads the rule via `useVocabularyDerivationRule`, seeds the form once.
 *  - create: `mode="create"` — blank rule, POST on save.
 *
 * `vocabularyType` is the immutable natural key: a required picker on
 * create (options = OPEN/derivable types from the `vocabulary_type` registry
 * — `useVocabularyTypes({ validationType: 'OPEN' })`, CZNA-390 slice S1 —
 * minus those already claimed by another rule), read-only on edit. In create
 * mode a "+ create new vocabulary type" link opens `CreateVocabularyTypeModal`
 * (CZNA-395) — the escape hatch for when no suitable OPEN type exists yet;
 * on success the registry is invalidated and the new type auto-selected. This
 * trigger is gated on `CREATE_VOCABULARY_TYPE_PERM`
 * (`czna-authorities.vocabulary-types.item.post`), NOT on `canWrite` — the
 * POST it drives is a different permission from derivation-rule write, and
 * the two are only bundled together via the `czna-authorities.all` catch-all
 * (code review CZNA-395 HIGH-1).
 * `thresholdStrategy` selects which
 * single threshold-parameter field is shown (FREQUENCY → minFrequency,
 * COVERAGE_PERCENTILE → coveragePercentile, EXPLICIT_LIST → whitelist as a
 * newline/comma-separated list).
 *
 * `sources` is a REPEATABLE list of MARC positions (CZNA-565), each one the
 * cascading trio of Selects this pane has always had: fieldTag →
 * subfieldCode → componentType, driven by the read-only MARC catalog
 * (`useMarcCatalog`) and the ontology's componentType bindings
 * (`useComponentBindings`, CZNA-381 / CZNA-433). Picking a field populates the
 * subfield options from the catalog; picking a subfield filters the ontology's
 * bindings for that (tag, subfield) pair into the componentType options (plus a
 * "(none)" sentinel that normalizes to `componentType: null`, i.e. a plain
 * record_data path). Only the user-driven onChange handlers on
 * fieldTag/subfieldCode clear the downstream selection(s) — programmatic
 * seeding via `reset()` never does.
 *
 * The cascade is per row, so the options of one source never depend on another;
 * a rule may legitimately mix a component source with a plain one. A row can be
 * added and removed, but the last one cannot be removed — a rule with no source
 * derives nothing, and the server rejects it with a 400 rather than storing it.
 *
 * "Derive now" (AC4, "Přegenerovat") is a dry-run-first flow: the button first
 * calls derive with `dryRun=true` and shows the resulting counts; only on
 * confirm does it call again with `dryRun=false`. There is only one derive
 * endpoint — dry-run is a preview step, not a separate action.
 */
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import { useStripes } from '@folio/stripes/core';
import { Pane, PaneMenu, PaneFooter, Button, TextField, TextArea, Checkbox, Select, Loading, MessageBanner, AccordionSet, Accordion, ConfirmationModal, Callout, } from '@folio/stripes/components';
import PaneHelpButton from '../PaneHelpButton';
import HelpTooltip from '../HelpTooltip';
import RunHistoryView from './RunHistoryView';
import CreateVocabularyTypeModal from './CreateVocabularyTypeModal';
import { useVocabularyDerivationRule, useVocabularyDerivationRules, useSaveVocabularyDerivationRule, useDeleteVocabularyDerivationRule, useDeriveVocabularyDerivationRule, } from '../../hooks/useVocabularyDerivationRules';
import { useMarcCatalog } from '../../hooks/useMarcCatalog';
import { useComponentBindings } from '../../hooks/useSemanticCatalog';
import { useVocabularyTypes } from '../../hooks/useVocabularyTypes';
import { catalogLabel } from '../../api/marcCatalogService';
import { getErrorInfo } from '../../utils/getErrorCode';
import { getErrorKind } from '../../utils/errorKind';
import { formatDerivationSources } from '../../utils/formatDerivationSource';
var WRITE_PERM = 'czna-authorities.admin.vocabulary-derivation-rules.write';
// CZNA-395 code review (HIGH-1) — the inline "create new vocabulary type"
// affordance calls POST /czna-authorities/vocabulary-types, which the
// descriptor gates behind this permission, NOT `WRITE_PERM` above. The two
// are only bundled together inside the catch-all `czna-authorities.all` —
// a user with derivation-rule write but not the full bundle must not see
// (or be able to submit) the create-type trigger, or they hit a 403.
var CREATE_VOCABULARY_TYPE_PERM = 'czna-authorities.vocabulary-types.item.post';
var THRESHOLD_STRATEGIES = ['FREQUENCY', 'COVERAGE_PERCENTILE', 'EXPLICIT_LIST'];
var whitelistToText = function (whitelist) { return (whitelist !== null && whitelist !== void 0 ? whitelist : []).join('\n'); };
var textToWhitelist = function (text) {
    return text
        .split(/[\n,]/)
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; });
};
var EMPTY_SOURCE = { fieldTag: '', subfieldCode: '', componentType: '' };
var toFormValues = function (rule) { return ({
    vocabularyType: rule.vocabularyType,
    // A persisted rule always has at least one source; the fallback keeps the form
    // usable (one blank row) rather than rendering an empty fieldset if it ever does not.
    sources: rule.sources.length > 0
        ? rule.sources.map(function (src) {
            var _a;
            return ({
                fieldTag: src.fieldTag,
                subfieldCode: src.subfieldCode,
                componentType: (_a = src.componentType) !== null && _a !== void 0 ? _a : '',
            });
        })
        : [__assign({}, EMPTY_SOURCE)],
    idPrefix: rule.idPrefix,
    thresholdStrategy: rule.thresholdStrategy,
    minFrequency: rule.minFrequency != null ? String(rule.minFrequency) : '',
    coveragePercentile: rule.coveragePercentile != null ? String(rule.coveragePercentile) : '',
    whitelistText: whitelistToText(rule.whitelist),
    enabled: rule.enabled,
    autoOnImport: rule.autoOnImport,
}); };
var EMPTY_FORM = {
    vocabularyType: '',
    sources: [__assign({}, EMPTY_SOURCE)],
    idPrefix: '',
    thresholdStrategy: 'FREQUENCY',
    minFrequency: '',
    coveragePercentile: '',
    whitelistText: '',
    enabled: true,
    autoOnImport: false,
};
/** Strip form-internal shape into the per-strategy threshold parameters (only the matching one is populated). */
var buildThresholdParams = function (values) { return ({
    minFrequency: values.thresholdStrategy === 'FREQUENCY' && values.minFrequency !== ''
        ? Number(values.minFrequency)
        : null,
    coveragePercentile: values.thresholdStrategy === 'COVERAGE_PERCENTILE' && values.coveragePercentile !== ''
        ? Number(values.coveragePercentile)
        : null,
    whitelist: values.thresholdStrategy === 'EXPLICIT_LIST' ? textToWhitelist(values.whitelistText) : null,
}); };
/** Form rows → wire shape: trim, and map the '(none)' componentType sentinel back to null. */
var buildSources = function (values) { return values.sources.map(function (src) { return ({
    fieldTag: src.fieldTag.trim(),
    subfieldCode: src.subfieldCode.trim(),
    componentType: src.componentType.trim() || null,
}); }); };
var buildCreateBody = function (values) { return (__assign(__assign({ vocabularyType: values.vocabularyType, sources: buildSources(values), idPrefix: values.idPrefix, thresholdStrategy: values.thresholdStrategy }, buildThresholdParams(values)), { enabled: values.enabled, autoOnImport: values.autoOnImport })); };
var buildUpdateBody = function (values, expectedUpdatedAt) { return (__assign(__assign({ expectedUpdatedAt: expectedUpdatedAt, sources: buildSources(values), idPrefix: values.idPrefix, thresholdStrategy: values.thresholdStrategy }, buildThresholdParams(values)), { enabled: values.enabled, autoOnImport: values.autoOnImport })); };
var DerivationRuleDetail = function (_a) {
    var _b, _c;
    var id = _a.id, mode = _a.mode, onClose = _a.onClose, onSaved = _a.onSaved, onDeleted = _a.onDeleted;
    var intl = useIntl();
    var stripes = useStripes();
    var isCreate = mode === 'create';
    var canWrite = stripes.hasPerm(WRITE_PERM);
    // CZNA-395 code review (HIGH-1) — gates the create-type trigger + modal on
    // the permission the POST actually needs (see constant doc above), not on
    // `canWrite` (derivation-rule write).
    var canCreateVocabularyType = stripes.hasPerm(CREATE_VOCABULARY_TYPE_PERM);
    var _d = useVocabularyDerivationRule(isCreate ? undefined : id), rule = _d.data, isLoading = _d.isLoading, isError = _d.isError;
    var catalogData = useMarcCatalog().data;
    var componentBindingsData = useComponentBindings().data;
    var existingRules = useVocabularyDerivationRules().data;
    // CZNA-390 (slice S1) — the vocabularyType picker reads OPEN/derivable types
    // live from the registry instead of the hand-maintained VOCABULARY_TYPE_CONFIG
    // (which was missing VOCABULARY_OCCUPATION entirely and capped at 14/27 types).
    var vocabularyTypes = useVocabularyTypes({ validationType: 'OPEN' }).vocabularyTypes;
    // CZNA-395 code review (LOW-1) — the type just created via the modal, kept
    // around only until the invalidated `useVocabularyTypes` query refetches
    // and genuinely includes it. Without this, `setValue('vocabularyType', ...)`
    // fires while the Select's own options are still the pre-create list, so
    // the controlled Select briefly shows blank (the value doesn't match any
    // option). Merged into `vocabularyTypeOptions` below, deduped by code once
    // the real list catches up.
    var _e = useState(null), optimisticVocabularyType = _e[0], setOptimisticVocabularyType = _e[1];
    var _f = useState(null), saveError = _f[0], setSaveError = _f[1];
    var _g = useState(false), conflict = _g[0], setConflict = _g[1];
    // CZNA-811 — set when a save changed admission and left stored terms below the saved
    // threshold: how many. Shown after the save went through, never before it.
    var _h = useState(null), noLongerQualifying = _h[0], setNoLongerQualifying = _h[1];
    var _j = useState(false), showDeleteModal = _j[0], setShowDeleteModal = _j[1];
    var _k = useState(false), showCreateTypeModal = _k[0], setShowCreateTypeModal = _k[1];
    var _l = useState(false), historyOpen = _l[0], setHistoryOpen = _l[1];
    var _m = useState(null), deriveError = _m[0], setDeriveError = _m[1];
    var _o = useState(null), derivePreview = _o[0], setDerivePreview = _o[1];
    var _p = useState(null), deriveSuccess = _p[0], setDeriveSuccess = _p[1];
    // Tracks WHAT is currently seeded into the form: 'create' for the blank
    // create-mode form, or the id of the rule last seeded in edit mode. Seeding
    // is a single id-keyed effect below — re-seeding happens only when this key
    // actually changes (a different rule, or a switch between create/edit),
    // never merely because `rule` got a new object identity from a background
    // refetch. See the effect below for the regression this guards against.
    var seededKeyRef = useRef(null);
    // CZNA-395 code review (LOW-2) — success confirmation for the create-type
    // modal. Owned here (not inside `CreateVocabularyTypeModal`) because the
    // modal unmounts its children immediately on close; the pane persists, so
    // the toast has somewhere to render from. Mirrors `DerivationRulesList`'s
    // calloutRef pattern for `onSaved`/`onDeleted`.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var calloutRef = useRef(null);
    var _q = useForm({
        defaultValues: EMPTY_FORM,
        mode: 'onChange',
    }), control = _q.control, handleSubmit = _q.handleSubmit, reset = _q.reset, watch = _q.watch, setValue = _q.setValue, _r = _q.formState, errors = _r.errors, isDirty = _r.isDirty;
    var thresholdStrategy = watch('thresholdStrategy');
    // Cascade drivers for the field/subfield/componentType pickers (CZNA-381), one set
    // per source row since CZNA-565. Only the explicit onChange handlers below clear
    // componentType — never an effect keyed off these watched values, so edit-mode
    // seeding via reset() is safe even if the catalog/registry queries haven't resolved
    // yet. `watch('sources')` (not useWatch) so a reset() is visible here too — MEMORY
    // rhf-usewatch-blind-to-reset-and-once-mocks.
    var sourceValues = (_b = watch('sources')) !== null && _b !== void 0 ? _b : [];
    var _s = useFieldArray({ control: control, name: 'sources' }), sourceFields = _s.fields, appendSource = _s.append, removeSource = _s.remove;
    // Seed the form from server data when — and only when — the identity of
    // "what should be in the form" actually changes: switching into create
    // mode, or loading a genuinely different rule id. `useVocabularyDerivationRule`
    // uses react-query defaults (staleTime 0, refetchOnMount/refetchOnWindowFocus
    // true), so `rule` routinely gets a NEW object identity on the same id from
    // a background refetch — comparing against `rule.id` (not `rule` itself, and
    // not a "have we ever seeded" boolean) is what keeps a background refetch
    // from clobbering an admin's in-progress unsaved edits (ui-czna-development
    // "initialize from server data only once" rule, extended to the warm-cache
    // case where `rule` is already defined on the very first render).
    useEffect(function () {
        if (isCreate) {
            if (seededKeyRef.current !== 'create') {
                seededKeyRef.current = 'create';
                reset(EMPTY_FORM);
            }
            return;
        }
        if (rule && seededKeyRef.current !== rule.id) {
            seededKeyRef.current = rule.id;
            reset(toFormValues(rule));
        }
    }, [rule, isCreate, reset]);
    var saveMutation = useSaveVocabularyDerivationRule({
        onSuccess: function (saved) {
            var _a;
            setSaveError(null);
            setConflict(false);
            setNoLongerQualifying((_a = saved.termsNoLongerQualifying) !== null && _a !== void 0 ? _a : null);
            onSaved(saved);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        info = _a.sent();
                        // CZNA-1625 — no answer in time: the save may have happened.
                        if (getErrorKind(info) === 'timeout') {
                            setSaveError(intl.formatMessage({ id: 'ui-czna-authorities.error.timeout' }));
                            return [2 /*return*/];
                        }
                        if (info.status === 409) {
                            setConflict(true);
                            return [2 /*return*/];
                        }
                        setSaveError(info.message || intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.save.error' }));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var deleteMutation = useDeleteVocabularyDerivationRule({
        onSuccess: function () { return onDeleted === null || onDeleted === void 0 ? void 0 : onDeleted(); },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        info = _a.sent();
                        // CZNA-1625 — no answer in time: the rule may have been deleted.
                        setSaveError(getErrorKind(info) === 'timeout'
                            ? intl.formatMessage({ id: 'ui-czna-authorities.error.timeout' })
                            : info.message || intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.delete.error' }));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var deriveMutation = useDeriveVocabularyDerivationRule({
        onSuccess: function (report) {
            if (report.dryRun) {
                setDeriveError(null);
                setDerivePreview(report);
            }
            else {
                setDerivePreview(null);
                setDeriveSuccess(report);
            }
        },
        onError: function (err, vars) { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        info = _a.sent();
                        setDerivePreview(null);
                        // CZNA-1625 — a real run with no answer in time may have written terms; a dry run writes nothing.
                        setDeriveError(!(vars === null || vars === void 0 ? void 0 : vars.dryRun) && getErrorKind(info) === 'timeout'
                            ? intl.formatMessage({ id: 'ui-czna-authorities.error.timeout' })
                            : info.message || intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.derive.error' }));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var onSubmit = function (values) {
        setSaveError(null);
        setNoLongerQualifying(null);
        if (isCreate) {
            saveMutation.mutate({ mode: 'create', body: buildCreateBody(values) });
        }
        else if (rule) {
            saveMutation.mutate({ mode: 'update', id: rule.id, body: buildUpdateBody(values, rule.updatedAt) });
        }
    };
    var handleConfirmDelete = function () {
        setShowDeleteModal(false);
        if (rule)
            deleteMutation.mutate(rule.id);
    };
    var handleDeriveNow = function () {
        if (!rule)
            return;
        setDeriveError(null);
        setDeriveSuccess(null);
        deriveMutation.mutate({ ruleId: rule.id, dryRun: true });
    };
    var handleConfirmDerive = function () {
        if (!rule)
            return;
        deriveMutation.mutate({ ruleId: rule.id, dryRun: false });
    };
    // CZNA-395 — created via the inline "+ create new vocabulary type" modal.
    // The type is guaranteed OPEN (the modal fixes validationType), so it is
    // always a valid pick for this create-mode-only picker; select it right
    // away instead of leaving the admin to find it in the (now-refetched) list.
    // `optimisticVocabularyType` covers the gap until that refetch lands (LOW-1);
    // the callout confirms the create succeeded (LOW-2).
    var handleVocabularyTypeCreated = function (created) {
        var _a;
        setShowCreateTypeModal(false);
        setOptimisticVocabularyType(created);
        setValue('vocabularyType', created.code, { shouldDirty: true, shouldValidate: true });
        (_a = calloutRef.current) === null || _a === void 0 ? void 0 : _a.sendCallout({
            type: 'success',
            message: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.createType.success' }, { code: created.code }),
        });
    };
    if (!isCreate && isLoading) {
        return (React.createElement(Pane, { defaultWidth: "50%", dismissible: true, onClose: onClose, paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.detail.loading" }) },
            React.createElement(Loading, null)));
    }
    if (!isCreate && (isError || !rule)) {
        return (React.createElement(Pane, { defaultWidth: "50%", dismissible: true, onClose: onClose, paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.detail.title" }) },
            React.createElement(MessageBanner, { type: "error" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.detail.loadError" }))));
    }
    var thresholdStrategyOptions = THRESHOLD_STRATEGIES.map(function (s) { return ({
        value: s,
        label: intl.formatMessage({ id: "ui-czna-authorities.derivationRules.thresholdStrategy.".concat(s) }),
    }); });
    // --- Cascading pickers (CZNA-381, SCR bindings) ---
    var catalogFields = (_c = catalogData === null || catalogData === void 0 ? void 0 : catalogData.fields) !== null && _c !== void 0 ? _c : {};
    var fieldTagOptions = Object.keys(catalogFields).sort().map(function (tag) { return ({
        value: tag,
        label: "".concat(tag, " \u2014 ").concat(catalogLabel(catalogFields[tag].label)),
    }); });
    /**
     * Keep a stored value selectable even when the read-only catalog / ontology does not
     * list it (CZNA-565). A controlled `<select>` whose value matches no option silently
     * falls back to the first one, so a rule pointing at a tag the catalog does not know
     * would DISPLAY a different tag — and saving the untouched form would then write that
     * different tag to the rule. Appending the current value keeps display honest and the
     * round-trip lossless; it is a no-op whenever the option is already there.
     */
    var withCurrentValue = function (options, value) { return (!value || options.some(function (o) { return o.value === value; })
        ? options
        : __spreadArray(__spreadArray([], options, true), [{ value: value, label: value }], false)); };
    // Per-row cascade (CZNA-565): each source's subfield options come from ITS OWN field
    // tag and its componentType options from its own (tag, subfield) pair, so two rows of
    // the same rule never constrain each other.
    var subfieldOptionsFor = function (fieldTag) {
        var _a, _b;
        return ((_b = (_a = catalogFields[fieldTag]) === null || _a === void 0 ? void 0 : _a.subfields) !== null && _b !== void 0 ? _b : []).map(function (sf) { return ({
            value: sf.code,
            label: "$".concat(sf.code, " \u2014 ").concat(catalogLabel(sf.label)),
        }); });
    };
    var bindingsFor = function (fieldTag, subfieldCode) {
        var _a;
        return ((_a = componentBindingsData === null || componentBindingsData === void 0 ? void 0 : componentBindingsData.bindings) !== null && _a !== void 0 ? _a : []).filter(function (b) { return b.tag === fieldTag && b.subfield === subfieldCode; });
    };
    var componentTypeNoneOption = {
        value: '',
        label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.picker.componentType.none' }),
    };
    var componentTypeOptionsFor = function (fieldTag, subfieldCode) { return __spreadArray([
        componentTypeNoneOption
    ], bindingsFor(fieldTag, subfieldCode).map(function (b) { return ({ value: b.componentType, label: b.componentType }); }), true); };
    // vocabularyType is the immutable natural key: on create, offer only OPEN/derivable
    // types from the registry (CZNA-390 slice S1) not already claimed by another rule;
    // on edit, it's a fixed single option (the Select stays disabled, but still needs a
    // matching option to display).
    var usedVocabularyTypes = new Set((existingRules !== null && existingRules !== void 0 ? existingRules : []).map(function (r) { return r.vocabularyType; }));
    var vocabularyTypeLabel = function (t) { var _a; return (((_a = intl.locale) !== null && _a !== void 0 ? _a : '').toLowerCase().startsWith('cs') ? t.labelCs : (t.labelEn || t.labelCs)); };
    // CZNA-395 code review (LOW-1) — append the optimistically-created type only
    // while the refetch triggered by `useCreateVocabularyType`'s invalidation
    // hasn't caught up yet (i.e. it isn't in `vocabularyTypes` for real yet).
    // Once it lands for real, this is a no-op — no duplicate option.
    var vocabularyTypesWithOptimistic = optimisticVocabularyType
        && !vocabularyTypes.some(function (t) { return t.code === optimisticVocabularyType.code; })
        ? __spreadArray(__spreadArray([], vocabularyTypes, true), [optimisticVocabularyType], false) : vocabularyTypes;
    var vocabularyTypeOptions = isCreate
        ? vocabularyTypesWithOptimistic
            .filter(function (t) { return !usedVocabularyTypes.has(t.code); })
            .map(function (t) { return ({ value: t.code, label: vocabularyTypeLabel(t) }); })
        : (rule ? [{ value: rule.vocabularyType, label: rule.vocabularyType }] : []);
    var paneTitle = isCreate
        ? intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.create.title' })
        : ((rule === null || rule === void 0 ? void 0 : rule.vocabularyType) || intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.detail.title' }));
    var saveDisabled = !canWrite || saveMutation.isLoading || (!isCreate && !isDirty);
    var lastMenu = (React.createElement(PaneMenu, null,
        React.createElement(PaneHelpButton, null,
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.help.intro" }))));
    var footer = (React.createElement(PaneFooter, { renderEnd: (React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", form: "derivation-rule-form", disabled: saveDisabled },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.action.save" }))), renderStart: (React.createElement(Button, { buttonStyle: "default", marginBottom0: true, onClick: onClose },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.action.cancel" }))) }));
    return (React.createElement(Pane, { defaultWidth: "50%", dismissible: true, onClose: onClose, paneTitle: paneTitle, paneSub: rule ? formatDerivationSources(rule.sources) : undefined, lastMenu: lastMenu, footer: canWrite ? footer : undefined },
        !canWrite && (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.detail.readOnly" }))),
        conflict && (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.save.conflict" }))),
        saveError && (React.createElement(MessageBanner, { type: "error", dismissible: true, onExited: function () { return setSaveError(null); } }, saveError)),
        noLongerQualifying !== null && (React.createElement(MessageBanner, { type: "warning", dismissible: true, onExited: function () { return setNoLongerQualifying(null); } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.save.termsNoLongerQualifying", values: { count: noLongerQualifying } }))),
        React.createElement("form", { id: "derivation-rule-form", onSubmit: handleSubmit(onSubmit) },
            React.createElement(Controller, { name: "vocabularyType", control: control, rules: { required: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.validation.vocabularyType.required' }) }, render: function (_a) {
                    var _b;
                    var field = _a.field;
                    return (React.createElement("div", null,
                        React.createElement(Select, __assign({}, field, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.vocabularyType' }), dataOptions: vocabularyTypeOptions, error: (_b = errors.vocabularyType) === null || _b === void 0 ? void 0 : _b.message, required: true, disabled: !isCreate || !canWrite, onChange: function (e) { return field.onChange(e.target.value); } })),
                        React.createElement(HelpTooltip, { testKey: "vocabularyType", messageId: "ui-czna-authorities.derivationRules.help.vocabularyType" }),
                        isCreate && canCreateVocabularyType && (React.createElement(Button, { buttonStyle: "link", marginBottom0: true, onClick: function () { return setShowCreateTypeModal(true); }, "data-testid": "create-vocabulary-type-button" },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.createType.trigger" })))));
                } }),
            React.createElement("fieldset", { "data-testid": "derivation-sources" },
                React.createElement("legend", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.field.sources" })),
                React.createElement(HelpTooltip, { testKey: "sources", messageId: "ui-czna-authorities.derivationRules.help.sources" }),
                sourceFields.map(function (sourceField, index) {
                    var _a, _b, _c, _d, _e;
                    var rowFieldTag = (_b = (_a = sourceValues[index]) === null || _a === void 0 ? void 0 : _a.fieldTag) !== null && _b !== void 0 ? _b : '';
                    var rowSubfieldCode = (_d = (_c = sourceValues[index]) === null || _c === void 0 ? void 0 : _c.subfieldCode) !== null && _d !== void 0 ? _d : '';
                    var rowBindings = bindingsFor(rowFieldTag, rowSubfieldCode);
                    var rowErrors = (_e = errors.sources) === null || _e === void 0 ? void 0 : _e[index];
                    return (React.createElement("div", { key: sourceField.id, "data-testid": "derivation-source-".concat(index) },
                        React.createElement(Controller, { name: "sources.".concat(index, ".fieldTag"), control: control, rules: { required: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.validation.fieldTag.required' }) }, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement("div", null,
                                    React.createElement(Select, __assign({}, field, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.fieldTag' }), dataOptions: withCurrentValue(fieldTagOptions, rowFieldTag), error: (_b = rowErrors === null || rowErrors === void 0 ? void 0 : rowErrors.fieldTag) === null || _b === void 0 ? void 0 : _b.message, required: true, disabled: !canWrite, onChange: function (e) {
                                            var newValue = e.target.value;
                                            field.onChange(newValue);
                                            // A new field invalidates whatever subfield/componentType was
                                            // previously picked IN THIS ROW — reset both, and only here.
                                            setValue("sources.".concat(index, ".subfieldCode"), '');
                                            setValue("sources.".concat(index, ".componentType"), '');
                                        } }))));
                            } }),
                        React.createElement(Controller, { name: "sources.".concat(index, ".subfieldCode"), control: control, rules: { required: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.validation.subfieldCode.required' }) }, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement("div", null,
                                    React.createElement(Select, __assign({}, field, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.subfieldCode' }), dataOptions: withCurrentValue(subfieldOptionsFor(rowFieldTag), rowSubfieldCode), 
                                        // Always supply a (disabled) placeholder option — not just while no
                                        // field is picked yet — so a reset-to-'' value (fired when the field
                                        // changes) always has a matching blank option to bind to instead of
                                        // the browser silently defaulting the controlled <select> to the
                                        // first real subfield in the list.
                                        placeholder: !rowFieldTag
                                            ? intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.picker.subfieldCode.selectFieldFirst' })
                                            : intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.picker.subfieldCode.placeholder' }), error: (_b = rowErrors === null || rowErrors === void 0 ? void 0 : rowErrors.subfieldCode) === null || _b === void 0 ? void 0 : _b.message, required: true, disabled: !canWrite || !rowFieldTag, onChange: function (e) {
                                            var newValue = e.target.value;
                                            field.onChange(newValue);
                                            // A new subfield invalidates the previously picked componentType.
                                            setValue("sources.".concat(index, ".componentType"), '');
                                        } }))));
                            } }),
                        React.createElement(Controller, { name: "sources.".concat(index, ".componentType"), control: control, render: function (_a) {
                                var _b, _c;
                                var field = _a.field;
                                return (React.createElement("div", null,
                                    React.createElement(Select, __assign({}, field, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.componentType' }), dataOptions: withCurrentValue(componentTypeOptionsFor(rowFieldTag, rowSubfieldCode), (_c = (_b = sourceValues[index]) === null || _b === void 0 ? void 0 : _b.componentType) !== null && _c !== void 0 ? _c : ''), disabled: !canWrite || rowBindings.length === 0, onChange: function (e) { return field.onChange(e.target.value); } }))));
                            } }),
                        canWrite && (React.createElement(Button, { buttonStyle: "danger", marginBottom0: true, 
                            // The last row can never be removed: a rule with no source derives
                            // nothing, and the server rejects an empty list with a 400. Disabling
                            // the button is the cheaper way to say so than a round trip.
                            disabled: sourceFields.length <= 1, onClick: function () { return removeSource(index); }, "data-testid": "remove-source-".concat(index) },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.action.removeSource" })))));
                }),
                canWrite && (React.createElement(Button, { buttonStyle: "default", marginBottom0: true, onClick: function () { return appendSource(__assign({}, EMPTY_SOURCE)); }, "data-testid": "add-source" },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.action.addSource" })))),
            React.createElement(Controller, { name: "idPrefix", control: control, rules: { required: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.validation.idPrefix.required' }) }, render: function (_a) {
                    var _b;
                    var field = _a.field;
                    return (
                    /* The "?" sits beside the control, not inside `label` — same shape as
                       every Select above. It used to be nested in the label, which was
                       harmless while it was a non-interactive <span role="img">; since
                       CZNA-505 it is a real <button>, and a button inside `<label htmlFor>`
                       both lands in the input's computed accessible name and makes
                       `getByLabelText` ambiguous. */
                    React.createElement("div", null,
                        React.createElement(TextField, __assign({}, field, { "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.idPrefix' }), label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.idPrefix' }), error: (_b = errors.idPrefix) === null || _b === void 0 ? void 0 : _b.message, required: true, disabled: !canWrite })),
                        React.createElement(HelpTooltip, { testKey: "idPrefix", messageId: "ui-czna-authorities.derivationRules.help.idPrefix" })));
                } }),
            React.createElement(Controller, { name: "thresholdStrategy", control: control, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement("div", null,
                        React.createElement(Select, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.thresholdStrategy' }), value: field.value, dataOptions: thresholdStrategyOptions, disabled: !canWrite, onChange: function (e) { return field.onChange(e.target.value); } }),
                        React.createElement(HelpTooltip, { testKey: "thresholdStrategy", messageId: "ui-czna-authorities.derivationRules.help.thresholdStrategy" })));
                } }),
            thresholdStrategy === 'FREQUENCY' && (React.createElement(Controller, { name: "minFrequency", control: control, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement("div", null,
                        React.createElement(TextField, __assign({}, field, { inputMode: "numeric", "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.minFrequency' }), label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.minFrequency' }), disabled: !canWrite })),
                        React.createElement(HelpTooltip, { testKey: "minFrequency", messageId: "ui-czna-authorities.derivationRules.help.minFrequency" })));
                } })),
            thresholdStrategy === 'COVERAGE_PERCENTILE' && (React.createElement(Controller, { name: "coveragePercentile", control: control, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement("div", null,
                        React.createElement(TextField, __assign({}, field, { inputMode: "decimal", "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.coveragePercentile' }), label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.coveragePercentile' }), disabled: !canWrite })),
                        React.createElement(HelpTooltip, { testKey: "coveragePercentile", messageId: "ui-czna-authorities.derivationRules.help.coveragePercentile" })));
                } })),
            thresholdStrategy === 'EXPLICIT_LIST' && (React.createElement(Controller, { name: "whitelistText", control: control, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement("div", null,
                        React.createElement(TextArea, __assign({}, field, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.whitelist' }), placeholder: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.whitelist.placeholder' }), disabled: !canWrite })),
                        React.createElement(HelpTooltip, { testKey: "whitelist", messageId: "ui-czna-authorities.derivationRules.help.whitelist" })));
                } })),
            React.createElement(Controller, { name: "enabled", control: control, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement(Checkbox, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.enabled' }), checked: field.value, disabled: !canWrite, onChange: function (e) { return field.onChange(e.target.checked); } }));
                } }),
            React.createElement(Controller, { name: "autoOnImport", control: control, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement(Checkbox, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.field.autoOnImport' }), checked: field.value, disabled: !canWrite, onChange: function (e) { return field.onChange(e.target.checked); } }));
                } })),
        !isCreate && rule && (React.createElement("div", { style: { marginTop: '1rem', marginBottom: '1rem' } },
            React.createElement(Button, { marginBottom0: true, onClick: handleDeriveNow, disabled: !rule.enabled || deriveMutation.isLoading, "data-testid": "derive-now-button" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.action.deriveNow" })),
            !rule.enabled && (React.createElement("div", { style: { color: '#666', fontSize: '0.85em', marginTop: '4px' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.derive.disabledHint" }))),
            deriveError && (React.createElement(MessageBanner, { type: "error", dismissible: true, onExited: function () { return setDeriveError(null); } }, deriveError)),
            deriveSuccess && (React.createElement(MessageBanner, { type: "success", dismissible: true, onExited: function () { return setDeriveSuccess(null); } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.derive.success", values: {
                        created: deriveSuccess.termsCreated,
                        existing: deriveSuccess.termsAlreadyPresent,
                        rematched: deriveSuccess.componentsRematched,
                    } }))))),
        !isCreate && rule && canWrite && (React.createElement("div", { style: { marginTop: '1rem' } },
            React.createElement(Button, { buttonStyle: "danger", marginBottom0: true, onClick: function () { return setShowDeleteModal(true); }, disabled: deleteMutation.isLoading },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.derivationRules.action.delete" })))),
        !isCreate && rule && (React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.runs.title' }), open: historyOpen, onToggle: function () { return setHistoryOpen(function (o) { return !o; }); }, id: "derivation-rule-history-accordion" },
                React.createElement(RunHistoryView, { ruleId: rule.id, enabled: historyOpen })))),
        React.createElement(ConfirmationModal, { open: showDeleteModal, heading: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.confirmDelete.heading' }), message: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.confirmDelete.message' }), onConfirm: handleConfirmDelete, onCancel: function () { return setShowDeleteModal(false); }, confirmLabel: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.action.confirm' }), isConfirmButtonDisabled: deleteMutation.isLoading, buttonStyle: "danger" }),
        React.createElement(ConfirmationModal, { open: !!derivePreview, heading: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.confirmDerive.heading' }), message: derivePreview ? intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.confirmDerive.message' }, {
                created: derivePreview.termsCreated,
                existing: derivePreview.termsAlreadyPresent,
                rematched: derivePreview.componentsRematched,
            }) : '', onConfirm: handleConfirmDerive, onCancel: function () { return setDerivePreview(null); }, confirmLabel: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.action.confirm' }), cancelLabel: intl.formatMessage({ id: 'ui-czna-authorities.derivationRules.action.cancel' }), isConfirmButtonDisabled: deriveMutation.isLoading, buttonStyle: "primary" }),
        isCreate && canCreateVocabularyType && (React.createElement(CreateVocabularyTypeModal, { open: showCreateTypeModal, onClose: function () { return setShowCreateTypeModal(false); }, onCreated: handleVocabularyTypeCreated })),
        React.createElement(Callout, { ref: calloutRef })));
};
export default DerivationRuleDetail;
